import { useMemo } from 'react';
import { useTable, useSortBy, useGlobalFilter, usePagination } from 'react-table';
import {
    TableWrapper,
    Table,
    HeaderCell,
    SDivContainer,
    BuscarInput,
    DivTable,
    ToolTipButton,
    HeaderActions,
    BodyActions,
    RowActions,
    LinhaTabela
} from './styles';
import { Col, OverlayTrigger, Pagination } from 'react-bootstrap';
import TrelloBoard from '../TrelloBoard';
import IconComponent from '../Icons';
import $ from "jquery";

function ResponsiveDataTable({
    columns,
    data,
    buttons = [],
    habilitaBuscar = true,
    habilitaCheckBox = false,
    isIgnorar = false,
    linhaCondicional,
    corCondicional='#9a3535',
    condicionalCheck='true',
    columnsFilter=[],
    paginacao = 0
}) {

    const isMobile = useMemo(() => localStorage.getItem('IsMobile') === 'true', []);
    const columnsOriginal = useMemo(() => [...columns], [columns]);
    const dataRow = useMemo(() => data.map((item) => ({ ...item, Check: item.Check || false })), [data]);

    const usuarioPermissao = JSON.parse(localStorage.getItem('permissaoRotina'))

    const exibeVisual = useMemo(() => usuarioPermissao && usuarioPermissao.includes('Acesso'), [usuarioPermissao]);
    const exibeAlterar = useMemo(() => usuarioPermissao && usuarioPermissao.includes('Alterar'), [usuarioPermissao]);
    const exibeExcluir = useMemo(() => usuarioPermissao && usuarioPermissao.includes('Excluir'), [usuarioPermissao]);

    const camposParaFiltro = useMemo(() => {
        if (columnsFilter.length > 0) return columnsFilter;
        if (data.length === 0) return [];
        return Object.keys(data[0]);
    }, [columnsFilter, data]);

    const handleCheckboxChange = (rowIndex) => {
        let statusCheck = false

        if (eval(condicionalCheck)){
            statusCheck = !data[rowIndex].Check            
        }

        data[rowIndex].Check = statusCheck;         
        $(`#checkTable_${rowIndex}`).prop('checked', statusCheck);
    };

    const globalFilterFunction = useMemo(() => {
        return (rows, columnIds, filterValue) => {

            if (!filterValue || filterValue.trim() === '') return rows;

            const lowerFilter = filterValue.toLowerCase();

            return rows.filter(row => {
                return camposParaFiltro.some((key) => {
                    const value = row.original[key];
                    return value && String(value).toLowerCase().includes(lowerFilter);
                });
            });

        };
    }, [camposParaFiltro]);

    const rowsVisibleFilter = (rows) => {
        const filtro = $('#input-buscar')[0].value;
        if (!filtro || filtro.trim() === '') return rows;

        const lowerFilter = filtro.toLowerCase();

        return rows.filter(row => {
            return camposParaFiltro.some((key) => {
                const value = row.original[key];
                return value && String(value).toLowerCase().includes(lowerFilter);
            });
        });;
    }
    
    const toggleAllCheckboxes = () => {
        const rowsVisible = rowsVisibleFilter(rows)
    
        rowsVisible.forEach((row) => {
            let statusCheck = false
            if (eval(condicionalCheck)){
                statusCheck = !data[row.index].Check            
            }
            
            data[row.index].Check = statusCheck;         
            $(`#checkTable_${row.index}`).prop('checked', statusCheck);
        });
    };

    const columnsWithCheckbox = useMemo(() => {

        if (!habilitaCheckBox) return [...columns];

        return [
            {
                Header: () => (
                    <input
                        type="checkbox"
                        onChange={toggleAllCheckboxes}
                        title="Selecionar Todos"
                    />
                ),
                accessor: 'check',
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        onChange={() => handleCheckboxChange(row.index)}
                        id={`checkTable_${row.index}`}
                    />
                ),
                disableSortBy: true,
            },
            ...columns,
        ];

    }, [columns, habilitaCheckBox, data]);

    const tableInstance = useTable(
        {
            columns: columnsWithCheckbox,
            data: dataRow,
            globalFilter: globalFilterFunction,
            initialState: {
                pageSize: paginacao > 0 ? paginacao : dataRow.length
            }
        },
        useGlobalFilter,
        useSortBy,
        ...(paginacao > 0 ? [usePagination] : [])
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        page,
        prepareRow,
        state,
        setGlobalFilter,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount
    } = tableInstance;

    const { globalFilter, pageIndex } = state;

    const rowsToRender = paginacao > 0 ? page : rows;

    if (isMobile) {

        const columnsConvert = columnsOriginal.map((col) => ({
            ...col,
            render: col.Cell || col.render,
        }));

        return (
            <TrelloBoard
                columns={columnsConvert}
                data={dataRow}
                titleLista=""
                columnsAditional={[]}
                buttons={buttons}
                mdColCard={12}
                isGridOrigin={true}
            />
        );
    }

    return (
        <>
            {habilitaBuscar && (
                <Col className="d-flex justify-content-end">
                    <BuscarInput
                        label="Buscar"
                        tipo="text"
                        value={globalFilter || ''}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        id={'input-buscar'}
                        placeholder="Buscar..."
                    />
                </Col>
            )}

            <DivTable>
                <TableWrapper>
                    <Table {...getTableProps()}>

                        <thead>

                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>

                                    {headerGroup.headers.map((column) => (
                                        <HeaderCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render('Header')}
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </HeaderCell>
                                    ))}

                                    {buttons.length > 0 && <HeaderActions>Ações</HeaderActions>}

                                </tr>
                            ))}

                        </thead>

                        <tbody {...getTableBodyProps()}>

                            {rowsToRender.map((row) => {

                                prepareRow(row);

                                return (

                                    <LinhaTabela
                                        key={row.original.id}
                                        {...row.getRowProps()}
                                        isCondicional={linhaCondicional ? linhaCondicional(row.original) : false}
                                        corLinha={corCondicional}
                                    >

                                        {row.cells.map((cell) => (
                                            <td {...cell.getCellProps()}>
                                                {cell.render('Cell')}
                                            </td>
                                        ))}

                                        {buttons.length > 0 && (

                                            <BodyActions>
                                                <RowActions>

                                                    {buttons.map((button, index) => {

                                                        const podeExibir =
                                                            (button.isVisual && exibeVisual) ||
                                                            (button.isAlterar && exibeAlterar) ||
                                                            (button.isExcluir && exibeExcluir) ||
                                                            isIgnorar;

                                                        const passaRegraExclude =
                                                            (button.regraExclude && !eval(button.regraExclude)) || !button.regraExclude;

                                                        if (podeExibir && passaRegraExclude) {
                                                            return (

                                                                <Col md="6" key={index} style={{padding: '0px 0.5lvw'}}>

                                                                    <OverlayTrigger overlay={<ToolTipButton>{button.label}</ToolTipButton>}>

                                                                        <SDivContainer onClick={() => button.action(row)} variant={button.style || "info"}>

                                                                            <IconComponent icon={button.icone} />
                                                                            <span>{button.label}</span>

                                                                        </SDivContainer>

                                                                    </OverlayTrigger>

                                                                </Col>

                                                            );

                                                        }

                                                        return null;

                                                    })}

                                                </RowActions>
                                            </BodyActions>

                                        )}

                                    </LinhaTabela>

                                );

                            })}

                        </tbody>

                    </Table>

                </TableWrapper>
            </DivTable>

            {paginacao > 0 && (

                <Pagination className="justify-content-center mt-3">

                    <Pagination.First
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                    />

                    <Pagination.Prev
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                    />

                    {pageOptions.map((pageNumber) => (
                        <Pagination.Item
                            key={pageNumber}
                            active={pageNumber === pageIndex}
                            onClick={() => gotoPage(pageNumber)}
                        >
                            {pageNumber + 1}
                        </Pagination.Item>
                    ))}

                    <Pagination.Next
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                    />

                    <Pagination.Last
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                    />

                </Pagination>

            )}

        </>
    );
}

export default ResponsiveDataTable;